import ApiService from '../apiservice'

class CidadeService extends ApiService {

  constructor() {
    super('/cidades')
  }

  listarCidades(estado) {
    console.log('codigo do estado', estado)
    return this.get(`/${estado}`);
  }
}

export default CidadeService;